import './index.css'

import React from 'react'
import UnifiedSearch from './unified-search'

export default class Search extends React.Component<any> {
  render(): React.ReactNode {
    return <UnifiedSearch />
  }
}
